import Dialog from "../1. Core/Controls/Dialog/Dialog";
import Select from "../1. Core/Controls/Select/Select";
import {NewsSource} from "./types";
import {ServerAPI} from "../1. Core/ServerAPI";
import TextField from "../1. Core/Controls/TextField/TextField";
import ImageTextField from "../1. Core/Controls/TextField/ImageTextField";


export default class EditNewsSourceDialog extends Dialog {


    private _NewsSource: NewsSource;
    private _typeSelect: Select;
    private _name: TextField;
    private _url: TextField;
    private _logoUrl: ImageTextField;


    constructor(props: any) {
        super(props);
    }

    _initFields(settings: object) {
        this._NewsSource = {Type: 'sharedog'} as NewsSource;
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = 'NewsSource';
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._OkRK = 'Save'
        this._AutoDestroy = true;
    }

    _render() {
        super._render();

        this._name = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name'
        });

        this._url = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Url'
        });

        this._logoUrl = new ImageTextField({
            ParentNode: this._contentNode,
            TextFieldSettings: {FloatingLabel: 'LogoUrl'}
        });

        this._typeSelect = new Select({
            FloatingLabel: 'SourceType',
            ParentNode: this._contentNode,
            Value: 'sharedog',
            Items: [
                {Content: 'Sharedog', Value: 'sharedog'},
                {Content: 'ESPN', Value: 'espn'},
                {Content: 'ESPN PT-BR', Value: 'espn-pt'},
                {Content: 'ESPN ES', Value: 'espn-es'},
                {Content: 'Ag.Fight', Value: 'agfight'},
                {Content: 'Super Lutas', Value: 'superlutas'},
                {Content: 'MMA.es', Value: 'mmaes'},
                {Content: 'Championat', Value: 'championat'},
                {Content: 'Sport Express', Value: 'sport-express'},
                {Content: 'MMA Junkie', Value: 'junkie'},
                {Content: 'Bloodandsweat', Value: 'bloodandsweat'},
                {Content: 'MMAWeekly', Value: 'mmaweekly'},
                {Content: 'Sports', Value: 'sports'},
            ]
        });


        this.refresh()
    }


    async refresh() {
        this._name.setValue(this._NewsSource.Name)
        this._url.setValue(this._NewsSource.RSSUrl)
        this._typeSelect.setValue(this._NewsSource.Type)
        this._logoUrl.setValue(this._NewsSource.LogoUrl || '')
    }


    async _onOkButtonClick() {

        this._NewsSource.Name = this._name.getValue()
        this._NewsSource.RSSUrl = this._url.getValue()
        this._NewsSource.Type = this._typeSelect.getValue()
        this._NewsSource.LogoUrl = this._logoUrl.getValue()

        if (this._NewsSource.Id)
            await ServerAPI.post(`/news-source/${this._NewsSource.Id}`, this._NewsSource)
        else
            await ServerAPI.post(`/news-source/`, this._NewsSource);


        this.EvOkButtonClick.fire(this);
        this.hide();
    }
}
